'use client';

import useTabStore from '@/utils/useTabStore';
import CommandCatalogue, { CommandCatalogueProps } from './CommandCatalogue';
import BookmarksCheatsheet from './BookmarksCheatsheet';
import ReviewsCheatsheet from './ReviewCheatsheet';

interface CheatsheetClientProps extends CommandCatalogueProps {}

const CheatsheetClient = (props: CheatsheetClientProps) => {
  const view = useTabStore((state) => state.cheatsheetView);
  const filter = useTabStore((state) => state.cheatsheetFilter);
  const showAsGrid = view === 'grid';
  const { cheats, ...rest } = props;

  if (filter === 'all') {
    return (
      <CommandCatalogue
        cheats={cheats}
        {...rest}
        showAsGrid={showAsGrid}
        showDifficulty
      />
    );
  }

  if (filter === 'reviews') {
    return (
      <ReviewsCheatsheet
        examples={cheats}
        {...rest}
        showAsGrid={showAsGrid}
        showDifficulty
      />
    );
  }

  console.log('filter', filter);

  return (
    <BookmarksCheatsheet
      examples={cheats}
      {...rest}
      showAsGrid={showAsGrid}
      showDifficulty
    />
  );
};

export default CheatsheetClient;
